import { render, staticRenderFns } from "./ProjectRevenueGraph.vue?vue&type=template&id=309d918e&scoped=true"
import script from "./ProjectRevenueGraph.vue?vue&type=script&lang=js"
export * from "./ProjectRevenueGraph.vue?vue&type=script&lang=js"
import style0 from "./ProjectRevenueGraph.vue?vue&type=style&index=0&id=309d918e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309d918e",
  null
  
)

export default component.exports